module.exports = __webpack_public_path__ + "static/media/logo_2.3a461387.svg";